<template>
  <div class="message_template" :style="screenHeight">
    <div class="fixed_search" style="height: 100px">
      <div class="fixed_search_input">
        <Select placeholder="渠道" v-model="orderChannel" clearable multiple title="渠道" :max-tag-count="2" >
          <Option v-for="item in orderChannelList" :value="item.id" :key="item.id">{{item.dictValue}}</Option>
        </Select>
      </div>
      <div class="fixed_search_input" >
        <Input placeholder="编号或主题" title="主题" v-model="orderTheme"/>
      </div>
      <div class="fixed_search_input" >
        <Select placeholder="客户名称" filterable title="客户名称" clearable multiple :max-tag-count="2" v-model="customerName">
          <Option v-for="item in customerList" :value="item.dictValue" :key="item.id">{{item.dictValue}}</Option>
        </Select>
      </div>
      <div class="fixed_search_input" >
        <Select placeholder="状态" clearable title="状态" multiple v-model="orderState" :max-tag-count="2" >
          <Option v-for="item in orderStateList" :value="item.id" :key="item.id">{{item.dictValue}}</Option>
        </Select>
      </div>
      <div class="fixed_search_input">
        <Select placeholder="优先级" clearable title="优先级" v-model="orderLevel" multiple :max-tag-count="2" >
          <Option v-for="item in orderLevelList" :value="item.id" :key="item.id">{{item.dictValue}}</Option>
        </Select>
      </div>
      <div class="fixed_search_input">
        <Select placeholder="SLA超时" v-model="slaTimeOut" clearable title="SLA超时">
         <Option value="1">是</Option>
         <Option value="0">否</Option>
        </Select>
      </div>
      <div class="fixed_search_input">
        <Select placeholder="处理人" clearable title="处理人" multiple v-model="orderHandler" :max-tag-count="1" >
          <OptionGroup label="员工">
            <Option v-for="item in orderHandlerList.list" :value="item.id" :key="item.id">{{item.dictValue}}</Option>
          </OptionGroup>
          <OptionGroup label="服务组">
            <Option v-for="item in orderHandlerList.orderGroupList" :value="item.id" :key="item.id">{{item.dictValue}}</Option>
          </OptionGroup>
        </Select>
      </div>
      <div class="date_selected fixed_search_input">
        <el-date-picker unlink-panels type="datetimerange" v-model="createTime" start-placeholder="创建开始时间" end-placeholder="创建结束时间" align="left" :default-time="['00:00:00', '23:59:59']" :editable="editable" :picker-options="pickerOptions"  format="yyyy-MM-dd HH:mm:ss"  value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
      </div>
      <div class="fixed_search_input">
        <Select v-model="countdown" placeholder="刷新时间选择" @on-change="handleCountdown">
          <Option v-for="(item,index) in countdownList" :value="item.value" :key="index">{{ item.name }}</Option>
        </Select>
      </div>
      <div class="fixed_operation_btn">
        <span title="刷新倒计时" style="color: red;margin-right: 5px">{{countdownTime}}</span>
        <Button type="primary" @click="initSearch">查询</Button>
        <Button type="primary" class="operation_btn reset_btn" @click="reset">重置</Button>
      </div>
    </div>
    <div class="fixed_table">
      <Spin size="large" fix v-if="spinShow"><Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
      <el-table :data="contentList" style="width: 100%" :height="tableHeight" class="element_table" stripe>
        <el-table-column align="center" width="100" :show-overflow-tooltip='true' label="渠道">
            <template slot-scope="scope" >
              <span style="margin-left: 10px">{{ scope.row.orderChannel }}</span>
            </template>
        </el-table-column>
        <el-table-column align="center" width="100" :show-overflow-tooltip='true' label="编号">
            <template slot-scope="scope">
              <span style="margin-left: 10px">#{{ scope.row.id }}</span>
            </template>
        </el-table-column>
        <el-table-column align="center" width="190" :show-overflow-tooltip='true' label="主题">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.orderTheme }}</span>
            </template>
        </el-table-column>
        <el-table-column align="center" width="150" :show-overflow-tooltip='true' label="客户名称">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.customerName }}</span>
            </template>
        </el-table-column>
        <el-table-column align="center" width="120" :show-overflow-tooltip='true' label="状态">
            <template slot-scope="scope">
                <div style="display:flex;align-items: center;margin-left: 10px;">
                  <p :style="{'background-color':scope.row.dictDescr ? JSON.parse(scope.row.dictDescr).color :'','width':'15px','height':'15px','line-height':'16px','text-align':'center','color': 'white'}"
                    >{{scope.row.dictDescr? JSON.parse(scope.row.dictDescr).shortValue:''}}</p>
                  <p :style="{'color':scope.row.dictDescr?JSON.parse(scope.row.dictDescr).color:'','margin-right':'10px','margin-left':'5px','font-size': '14px','width': '65%','text-overflow': 'ellipsis','overflow': 'hidden'}" >{{scope.row.orderState}}</p>
                </div>
            </template>
        </el-table-column>
        <el-table-column align="center" width="100" :show-overflow-tooltip='true' label="优先级">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.orderLevel }}</span>
            </template>
        </el-table-column>

        <el-table-column align="center" width="225" :show-overflow-tooltip='true' label="响应时长">
            <template slot-scope="scope">
              <div style="display:flex;align-items: center;margin-left: 15px;" v-if="scope.row.responseDurationKpi">
              <p :style="{'color':scope.row.isSlaTime == '0' ? '' : (scope.row.responseDurationKpi.indexOf('-') > -1 ? '#ff0000' :'#0C3'),'margin-right':'10px','display': 'flex','align-items': 'center'}" >
                <img src="@/assets/image/workOrder/timeOutRed.png" v-show="scope.row.isSlaTime != '0' && scope.row.responseDurationKpi.indexOf('-') > -1"/>
                <img src="@/assets/image/workOrder/timeOutGreen.png" v-show="scope.row.isSlaTime != '0' && scope.row.responseDurationKpi.indexOf('-') <= -1"/>

                <font style="color:#606266" v-if="scope.row.isSlaTime != '0'">{{scope.row.responseDurationKpi.indexOf('-') > -1 ? '超时':'剩余' }}&nbsp;</font>
                  {{ scope.row.isSlaTime == '0' ? scope.row.responseDurationKpi : (scope.row.responseDurationKpi.indexOf('-') > -1 ?  scope.row.responseDurationKpi.substring(0,scope.row.responseDurationKpi.indexOf('小时')).replace('-','') : scope.row.responseDurationKpi.substring(0,scope.row.responseDurationKpi.indexOf('小时')).replace('-','') ) }}
                   <font style="color:#606266" v-if="scope.row.responseDurationKpi.indexOf('小时') > -1">&nbsp;小时&nbsp;</font>
                  {{ scope.row.isSlaTime == '0' ? '' : (scope.row.responseDurationKpi.indexOf('-') > -1 ?  scope.row.responseDurationKpi.substring(scope.row.responseDurationKpi.indexOf('小时')+2,scope.row.responseDurationKpi.indexOf('分钟')) : scope.row.responseDurationKpi.substring(scope.row.responseDurationKpi.indexOf('小时') > -1 ? scope.row.responseDurationKpi.indexOf('小时')+2 : 0,scope.row.responseDurationKpi.indexOf('分钟'))) }}
                   <font style="color:#606266" v-if="scope.row.responseDurationKpi.indexOf('分钟') > -1">&nbsp;分钟</font>

              </p>
              </div>
            </template>
        </el-table-column>
        <el-table-column align="center" width="225" :show-overflow-tooltip='true' label="处理时长">
            <template slot-scope="scope">
              <div style="display:flex;align-items: center;margin-left: 15px;" v-if="scope.row.processDurationKpi">
              <p :style="{'color':scope.row.isSlaTime == '0' ? '' : (scope.row.processDurationKpi.indexOf('-') > -1 ? '#ff0000' :'#0C3'),'margin-right':'10px','display': 'flex','align-items': 'center'}" >
                <img src="@/assets/image/workOrder/timeOutRed.png" v-show="scope.row.isSlaTime != '0' && scope.row.processDurationKpi.indexOf('-') > -1"/>
                <img src="@/assets/image/workOrder/timeOutGreen.png" v-show="scope.row.isSlaTime != '0' && scope.row.processDurationKpi.indexOf('-') <= -1"/>
                <font style="color:#606266" v-if="scope.row.isSlaTime != '0'">{{scope.row.processDurationKpi.indexOf('-') > -1 ? '超时':'剩余' }}&nbsp;</font>

                  {{ scope.row.isSlaTime == '0' ? scope.row.processDurationKpi : (scope.row.processDurationKpi.indexOf('-') > -1 ?  scope.row.processDurationKpi.substring(0,scope.row.processDurationKpi.indexOf('小时')).replace('-','') : scope.row.processDurationKpi.substring(0,scope.row.processDurationKpi.indexOf('小时')).replace('-','') ) }}
                   <font style="color:#606266" v-if="scope.row.processDurationKpi.indexOf('小时') > -1">&nbsp;小时&nbsp;</font>
                  {{ scope.row.isSlaTime == '0' ? '' : (scope.row.processDurationKpi.indexOf('-') > -1 ?  scope.row.processDurationKpi.substring(scope.row.processDurationKpi.indexOf('小时')+2,scope.row.processDurationKpi.indexOf('分钟')) : scope.row.processDurationKpi.substring(scope.row.processDurationKpi.indexOf('小时') > -1 ? scope.row.processDurationKpi.indexOf('小时')+2 : 0,scope.row.processDurationKpi.indexOf('分钟'))) }}
                   <font style="color:#606266" v-if="scope.row.processDurationKpi.indexOf('分钟') > -1">&nbsp;分钟</font>
              </p>
              </div>
            </template>
        </el-table-column>
        <el-table-column align="center" width="180" :show-overflow-tooltip='true' label="处理人">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.orderHandler }}</span>
            </template>
        </el-table-column>
        <el-table-column align="center" width="150" :show-overflow-tooltip='true' label="创建时间">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.createTime }}</span>
            </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="150"  align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="clickDetail(scope.row.id,scope.row.orderTheme)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page_style">
      <Page :total="total" size="small" :page-size='pageSize' :current='currentPage' :page-size-opts="pageSizeList" show-total show-sizer  @on-change="changeCurrent" @on-page-size-change="changeSize"/>
      <div style="padding-top: 2px;">跳至</div><Input class="show-elevator" v-model="speedChangePage" @on-blur="handleCurrentPage"/><div style="padding-top: 2px;">页</div>
    </div>
  </div>
</template>

<script>
  import {publicFunClass} from '@/components/js/PublicFunClass.js'
  export default {
    name: "UndoneOrder",
    mixins:[publicFunClass],
    props:{
      pageCode:String
    },
    data(){
      return {
        countdown:'0',
        countdownTime:0,
        historyRefreshTime:0,
        countdownList:[{'value':'0','name':'停止刷新'},{'value':'1','name':'每隔1分钟刷新'},{'value':'5','name':'每隔5分钟刷新'},{'value':'10','name':'每隔10分钟刷新'},{'value':'30','name':'每隔30分钟刷新'}],
        showPageCount:0,
        total:0,
        currentPage:1,
        speedChangePage: 1,
        pageSize:20,
        editable:false,
        pageSizeList:[10,20,30,40,50,100,200],
        roleList:JSON.parse(localStorage.getItem("roleList")),
        tableHeight:600,
        screenHeight:{height:''},

        spinShow: true,

        contentList: [],

        Interval:'',
        orderChannel: [],
        orderChannelList: [],
        orderId: '',
        orderTheme: '',
        customerName: '',
        orderState: [],
        orderStateList: [],
        orderLevel: [],
        orderLevelList: [],
        createTime:'',
        orderHandler: [],
        orderHandlerList: [],
        slaTimeOut:'',
        customerList: [],
      }
    },
    methods:{
      //切换刷新时间
      handleCountdown:function(val){
        if(val){
           this.countdownTime= parseInt(val)*60;
        }else{
          if(this.countdownTime <= 0)
          return;
        }
        if(val=='0'){
          clearInterval(this.Interval);
          return false;
        }
        clearInterval(this.Interval);
        let that=this;
        this.Interval= setInterval(() =>{
          that.initCountdown();
        },1000);
      },
      initCountdown:function () {
        this.countdownTime=this.countdownTime-1;
        if(this.countdownTime==0){
          this.countdownTime=parseInt(this.countdown) * 60;
          this.initSearch();
          return false;
        }
      },
      reset:function(){
        this.orderChannel='';
        this.orderId='';
        this.orderTheme='';
        this.customerName='';
        this.orderState='';
        this.orderLevel='';
        this.createTime='';
        this.orderHandler='';
        this.slaTimeOut='';
      },
      initSearch:function () {
        let that=this;
        this.spinShow=true;
        let param={
          orderChannel: this.orderChannel.length > 0  ? this.orderChannel : '',
          id: this.orderId,
          orderTheme: this.orderTheme,
          customerName: this.customerName.length > 0  ? this.customerName : '',
          orderState: this.orderState.length > 0 ? this.orderState : '',
          orderLevel: this.orderLevel.length > 0 ? this.orderLevel : '',
          createTime: this.createTime ? this.createTime : '',
          orderHandler: this.orderHandler.length > 0 ? this.orderHandler : '',
          slaTimeOut: this.slaTimeOut,
          pageNum:this.currentPage,
          pageSize:this.pageSize,
          journalType:"null",
          menuId:"null"
        };
        this.$http.post("incompleteMonitor/toIndex.json",param) .then(function (res) {
          that.spinShow=false;
          let result=res.data.flag;
          if(result!="666"){
            that.$Modal.info({
              title:'提示',
              content:res.data.msg
            });
            return false;
          }
          that.contentList=res.data.obj.list.content;
          that.fieldList=res.data.obj.fields;
          that.total=res.data.obj.list.totalSize;

          let fields = res.data.obj.fields;
           // 搜索条件赋值
          if(fields.find(item => item.customColName === 'orderChannel'))
          that.orderChannelList = fields.find(item => item.customColName === 'orderChannel').list;

          if(fields.find(item => item.customColName === 'orderState'))
          that.orderStateList = fields.find(item => item.customColName === 'orderState').list;

          if(fields.find(item => item.customColName === 'orderLevel'))
          that.orderLevelList = fields.find(item => item.customColName === 'orderLevel').list;

          if(fields.find(item => item.customColName === 'orderHandler'))
          that.orderHandlerList = fields.find(item => item.customColName === 'orderHandler').list[0];

          if(fields.find(item => item.customColName === 'customerName'))
          that.customerList = fields.find(item => item.customColName === 'customerName').list;
        });
      },
      clickDetail:function(id,theme){
        this.$emit("showStandardPage","b_w_1-"+id+","+theme+',7_3-1-',[]);
        let param = {
          pageUuId:"b_w_1-"+id,
        };
        let newGroupList = [];
        newGroupList.push(param)
        this.$store.commit('addWorkOrderReserve',newGroupList);
      }
    },
    created(){
      this.screenHeight.height=this.mountHeight(91);
      let clientHeight=document.documentElement.clientHeight;
      this.tableHeight=clientHeight-230;
      // this.initSearch();
    },
    destroyed(){
      clearInterval(this.Interval);
    },
    watch:{
      calleeStartTime:function () {
        if(!this.calleeStartTime){
          this.calleeStartTime=[];
        }
      },
      callerStartTime:function () {
        if(!this.callerStartTime){
          this.callerStartTime=[];
        }
      },
      pageCode:function () {
        if(this.pageCode=='7_3' && this.showPageCount==0){
          this.showPageCount++;
          this.initSearch();
        }
        if(this.pageCode=='7_3'){
          this.handleCountdown();
        }
        if(this.pageCode!='7_3'){
          clearInterval(this.Interval);
          clearInterval(this.Interval);
        }
      }
    }
  }
</script>
<style>
.flexmytable .el-table th>.cell{
    overflow:hidden !important;
    text-overflow:ellipsis !important;
    white-space: nowrap !important;
  }
</style>
<style scoped>
 .message_template /deep/ ivu-tag ivu-tag-checked{
   height: 18px!important;
   line-height: 18px!important;
 }
 .message_template /deep/ ivu-icon ivu-icon-ios-close{
   top: 1px!important;
 }
 .message_template /deep/ .ivu-select-multiple .ivu-select-input {
   height: 18px !important;
   line-height: 18px !important;
 }
 .message_template /deep/ .ivu-select-multiple .ivu-tag{
   height: 18px!important;
   line-height: 18px!important;
 }
 .message_template /deep/ .ivu-select-multiple .ivu-tag .ivu-icon{
   line-height: 10px !important;
 }
</style>



// WEBPACK FOOTER //
// src/components/MonitorManage/UndoneOrder.vue